import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
  Typography,
  FormControl,
  InputLabel,
} from "@mui/material";
import { validateRequired } from "validations";
import axios from "axios";
import Swal from "sweetalert2";
import { useMaterialUIController } from "context";
import { useTheme } from "@mui/material/styles";
import { useGetAllCommissionsWithStoresQuery } from "../../redux/Slices/commissionsApi";
const AddCommissionForm = ({ onClose, onSuccess, initialData }) => {
  console.log("🚀 ~ AddCommissionForm ~ initialData:", initialData);
  const { data: AllCommitionTypeWithStore, isLoading: isLoadingAllCommitionTypeWithStore } =
    useGetAllCommissionsWithStoresQuery();
  console.log("🚀 ~ AddCommissionForm ~ AllCommitionTypeWithStore:", AllCommitionTypeWithStore);
  const [controller] = useMaterialUIController();
  const darkMode = controller.darkMode;
  const theme = useTheme();
  const [formData, setFormData] = useState({
    id: initialData?.id || null, // Add ID field
    is_active: initialData?.is_active || null,
    commission_type_id:
      initialData?.commission_rule?.id || initialData?.commission_type?.id || null,
    store_id: initialData?.store_id || null, // اختياري
    shipping_method_id: initialData?.shipping_method_id || null, // اختياري
    payment_method_id: initialData?.payment_method_id || null, // اختياري
    is_percentage: 1, // true أو false
    value: initialData?.commission_rule?.value || null, // القيمة الرقمية للعمولة
    min_value: initialData?.calculated_commission || initialData?.min_value || null, // اختياري
    max_value: initialData?.base_amount || initialData?.max_value || null, // اختياري
    starts_at: initialData?.starts_at || initialData?.created_at || null, // تاريخ البداية
  });
  console.log("🚀 ~ AddCommissionForm ~ formData:", formData);

  // Add useEffect to handle initial data
  useEffect(() => {
    if (initialData) {
      setFormData({
        id: initialData?.id || null, // Add ID field
        is_active: initialData?.is_active || null,
        commission_type_id:
          initialData?.commission_rule?.id || initialData?.commission_type?.id || null,
        store_id: initialData?.store_id || null, // اختياري
        shipping_method_id: initialData?.shipping_method_id || null, // اختياري
        payment_method_id: initialData?.payment_method_id || null, // اختياري
        is_percentage: 1, // true أو false
        value: initialData?.commission_rule?.value || null, // القيمة الرقمية للعمولة
        min_value: initialData?.calculated_commission || initialData?.min_value || null, // اختياري
        max_value: initialData?.base_amount || initialData?.max_value || null, // اختياري
        starts_at: initialData?.starts_at || initialData?.created_at || null, // تاريخ البداية
      });
    }
  }, [initialData]);
  const [errors, setErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    if (formSubmitted) validateForm();
  }, [formSubmitted]);

  const validateForm = () => {
    const newErrors = {};

    // if (!validateRequired(formData.code)) newErrors.store_id)) newErrors.store_id = "يجب إدخال المتجر"; // if (!validateRequired(formData.code = "يجب إدخال كود العملة مثل SAR";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // create and update commission rule
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    try {
      const formPayload = new FormData();
      // Append all form data including files
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined && key !== "id") {
          formPayload.append(key, value);
        }
      });

      // Show loading indicator
      Swal.fire({
        title: "جاري الحفظ...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
      console.log("Sending payload:", formPayload); // طباعة البيانات المرسلة
      const token = localStorage.getItem("user-token");
      const endpoint = formData.id
        ? `https://back.al-balad.sa/albalad/v1.0/administrator/commissions/rules/update/${formData.id}`
        : "https://back.al-balad.sa/albalad/v1.0/administrator/commissions/rules/store";

      const response = await axios.post(endpoint, formPayload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      // Close loading indicator
      Swal.close();

      if (response.data.status) {
        await Swal.fire({
          icon: "success",
          title: "تم الحفظ!",
          text: "تم حفظ البيانات بنجاح",
          confirmButtonText: "موافق",
          didOpen: () => {
            const container = document.querySelector(".swal2-container");
            container.style.zIndex = "99999";
          },
        });
        onSuccess();
        onClose();
      } else {
        throw new Error(response.data.message || "حدث خطأ غير متوقع");
      }
    } catch (error) {
      Swal.close();
      console.error("Error Details:", error);
      const errorMessage = error.response?.data?.message || error.message || "حدث خطأ أثناء  الحفظ";
      Swal.fire({
        icon: "error",
        title: "فشل الحفظ!",
        text: errorMessage,
        confirmButtonText: "موافق",
        didOpen: () => {
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
    } finally {
      setFormSubmitted(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      name: "",
      code: "",
      symbol: "",
      exchange_rate: 1.0,
      last_price: null,
      is_active: 1,
    });
    setErrors({});
    onClose();
  };
  return (
    <Box
      sx={{
        p: 3,
        width: 600,
        bgcolor: darkMode ? theme.palette.background.default : "background.paper",
        borderRadius: 2,
        boxShadow: 3,
        color: darkMode ? "white !important" : "inherit",
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">
          {formData.id ? "تعديل العمولة" : "إضافة عمولة جديدة"}
        </Typography>
      </Box>
      <Typography variant="subtitle1" gutterBottom fontWeight="bold">
        معلومات العمولة
      </Typography>
      {/* Main Form */}
      <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="commission-type-label">نوع العمولة</InputLabel>
          <Select
            label="نوع العمولة "
            labelId="commission-type-label"
            error={!!errors.commission_type_id}
            name="commission_type_id"
            value={formData.commission_type_id}
            onChange={handleChange}
            sx={{ height: 43 }}
          >
            {AllCommitionTypeWithStore?.commission_types?.map((commissionType) => (
              <MenuItem value={commissionType.id}>{commissionType.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        {!initialData && (
          <>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="store-label">المتجر</InputLabel>

              <Select
                label="المتجر "
                labelId="store-label"
                name="store_id"
                value={Number(formData.store_id)}
                onChange={handleChange}
                sx={{ height: 43 }}
              >
                {AllCommitionTypeWithStore?.stores?.map((store) => (
                  <MenuItem value={store.id}>{store.name_ar}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="shipping-method-label">شركة الشحن</InputLabel>
              <Select
                label="شركة الشحن"
                labelId="shipping-method-label"
                name="shipping_method_id"
                value={formData.shipping_method_id}
                onChange={handleChange}
                sx={{ height: 43 }}
              >
                {AllCommitionTypeWithStore?.shipping_methods?.map((shippingMethod) => (
                  <MenuItem value={shippingMethod.id}>{shippingMethod.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="payment-method-label">طرق الدفع</InputLabel>
              <Select
                labelId="payment-method-label"
                label="طرق الدفع"
                name="payment_method_id"
                value={Number(formData.payment_method_id)}
                onChange={handleChange}
                sx={{ height: 43 }}
              >
                {AllCommitionTypeWithStore?.payment_methods?.map((paymentMethod) => (
                  <MenuItem key={paymentMethod.id} value={paymentMethod.id}>
                    {paymentMethod.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </>
        )}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="is_active">حالة العمولة </InputLabel>
          <Select
            labelId="activing"
            label="حالة العمولة"
            name="is_active"
            value={Boolean(formData.is_active)}
            onChange={handleChange}
            sx={{ height: 43 }}
          >
            <MenuItem value="true">نشط</MenuItem>
            <MenuItem value="false">غير نشط</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <TextField
            label="نسبة العمولة %"
            name="value"
            type="number"
            inputProps={{ min: 0, max: 100 }}
            value={formData.value || ""}
            onChange={handleChange}
          />
        </FormControl>
      </Box>
      <Box display="flex" alignItems="center" justifyContent="center" gap={2}>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <TextField
            label="المبلغ الاساسي "
            name="max_value"
            type="number"
            inputProps={{ step: "any", min: 0 }}
            value={formData?.max_value || ""}
            onChange={handleChange}
          />
        </FormControl>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <TextField
            label="قيمة العمولة"
            name="min_value"
            type="number"
            inputProps={{ step: "any", min: 0 }}
            value={formData.min_value || ""}
            onChange={handleChange}
          />
        </FormControl>
        <FormControl fullWidth error={!!errors.code} sx={{ mb: 2 }}>
          <TextField
            type="date"
            name="starts_at"
            label="تاريخ البدء"
            value={formData?.initialData?.created_at}
            onChange={handleChange}
            required
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </FormControl>
      </Box>
      {/* Actions Section */}
      <Box mt={4} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" color="textSecondary">
          * الحقول المطلوبة
        </Typography>

        <Box display="flex" gap={2}>
          <Button variant="contained" color="error" onClick={handleCancel} sx={{ px: 4 }}>
            إلغاء
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="default"
            // disabled={Object.keys(errors).length > 0}
            sx={{ px: 4, color: "white !important", bgcolor: "#b88c36 !important" }}
            onClick={handleSubmit}
          >
            حفظ
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddCommissionForm;
